/**
 * Типы общих тикеров в тулбаре
 * 	- системные
 * 	- кастомные
 */
export enum TickerType {
	system = 'system',
	custom = 'custom',
}

export enum TickerClickAction {
	openLink = 'openLink',
	openTasksList = 'openTasksList',
}

export enum TickerIconSet {
	material = 'material',
}

export interface ITickerDto {
	id: number;
	name: string;
	type: TickerType;
	iconSet?: TickerIconSet;
	iconFromSet?: string;
	iconCss?: string;
	url?: string;
	gridUrl?: string;
	clickAction?: TickerClickAction;
	color?: string;
	value?: any;
}

export interface ICustomAssistantTickerDto {
	tickers: ITickerDto[];
	userId: number;
	userName: string;
}

/**@deprecated use  */
export interface ISystemTickersDto {
	DirectorSignaturesCount: number;
	HasChatInvites: boolean;
	Milestones: number;
	MissedCalls: number;
	OverDueTasksCount: number;
	OverdueSigns: number;
	QuestionsCount: number;
	SignaturesCount: number;
	UnreadCommentsCount: number;
	WasOffline: boolean;
	UnreadChatCommentsCount: number;
	favoriteComments: number;
}

export interface ISystemTickersDto2 {
	allTasksUserOwns: number;
	allTasksUserPerforms: number;
	unreadCommentsCount: number;
	questionsCount: number;
	overDueTasksCount: number;
	signaturesCount: number;
	directorSignaturesCount: number;
	overdueSigns: number;
	missedCalls: number;
	milestones: number;
	myQuestionsCount: number;
	unreadChatCommentsCount: number;
	badge: number;
	favoriteComments: number;
}

export interface ISystemTickersNamesDto2 {
	unreadCommentsCount: string;
	questionsCount: string;
	overDueTasksCount: string;
	signaturesCount: string;
	directorSignaturesCount: string;
	overdueSigns: string;
	missedCalls: string;
	milestones: string;
	myQuestionsCount: string;
	unreadChatCommentsCount: string;
	badge: string;
	favoriteComments: string;
}
